var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartActive = function SvgHeartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#262525",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C62F0",
    d: "M6.406 36a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.902 19.1-.1.1c-.5.5-1.1.8-1.8.8h-2c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h1l1.3-1.3c.5-.5 1.2-.8 1.9-.7.7 0 1.3.3 1.7.8l1.7 2 .1-.1c.5-.5 1.1-.7 1.8-.7h1.4c-.2-1.2-.7-2.4-1.6-3.2-2-2-5.1-2.2-7.3-.6-2.6-1.9-6.1-1.3-7.9 1.2-1.6 2.3-1.4 5.4.6 7.3l5.4 5.4c1.1 1.1 2.8 1.1 3.9 0l3.2-3.2c-.6-.1-1.1-.4-1.5-.8zm8.1-2.6h-2.5c-.3 0-.5.1-.7.3l-1.3 1.2-2.8-3.2c-.2-.2-.4-.3-.7-.3s-.6.1-.7.3l-1.7 1.7h-1.6c-.6 0-1 .4-1 1s.4 1 1 1h2c.3 0 .5-.1.7-.3l1.2-1.2 2.8 3.2c.2.2.4.3.7.3s.5-.1.7-.3l1.7-1.7h2.2c.6 0 1-.4 1-1s-.4-1-1-1"
  })));
};
export default SvgHeartActive;